<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">person_outline</span>
      <h2>Gestion des Clients</h2>
    </div>

    <p class="section-intro">
      Ce module permet de créer et gérer les fiches clients,
      consulter leurs portefeuilles et suivre leurs soldes.
    </p>

    <!-- ===== FICHE CLIENT ===== -->
    <h3 class="sub-title">Créer un client</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Champ</th><th>Type</th><th>Obligatoire</th><th>Ce qu'il faut saisir</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Nom complet</strong></td><td>Texte</td><td><span class="required-badge badge-yes">Oui</span></td><td>Nom et prénom(s) du client ou nom de la société.</td></tr>
          <tr><td><strong>Raison sociale</strong></td><td>Texte</td><td><span class="required-badge badge-no">Non</span></td><td>Dénomination officielle de l'entreprise.</td></tr>
          <tr><td><strong>Contact</strong></td><td>Texte</td><td><span class="required-badge badge-yes">Oui</span></td><td>Numéro de téléphone du client.</td></tr>
          <tr><td><strong>Email</strong></td><td>Email</td><td><span class="required-badge badge-no">Non</span></td><td>Adresse courriel du client.</td></tr>
          <tr><td><strong>Adresse</strong></td><td>Texte</td><td><span class="required-badge badge-no">Non</span></td><td>Adresse physique ou postale du client.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure : Ajouter un nouveau client</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Ouvrez le module <strong>Clients</strong> depuis le menu latéral.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Cliquez sur <span class="btn-ref">Ajouter</span>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Remplissez le champ <em>Nom complet</em> (obligatoire) et le <em>Contact</em>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p>Complétez les autres champs si disponibles : <em>Raison sociale</em>, <em>Email</em>, <em>Adresse</em>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p>Cliquez sur <span class="btn-ref">Soumettre</span>. Le client apparaît dans le tableau.</p>
      </div>
    </div>

    <!-- ===== MODIFIER / SUPPRIMER ===== -->
    <h3 class="sub-title">Modifier ou supprimer un client</h3>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Trouvez le client dans le tableau (utilisez la barre de recherche pour aller plus vite).</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Cliquez sur l'icône <span class="material-icons-sharp" style="font-size:14px;vertical-align:middle">edit</span> <strong>Modifier</strong> pour ouvrir le formulaire pré-rempli. Modifiez les champs, puis cliquez sur <span class="btn-ref">Soumettre</span>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Pour supprimer, cliquez sur l'icône <span class="material-icons-sharp" style="font-size:14px;vertical-align:middle;color:#e53935">delete</span> <strong>Supprimer</strong>. Confirmez en cliquant sur <span class="btn-ref">Oui je veux</span>.</p>
      </div>
    </div>

    <!-- ===== PORTEFEUILLE ===== -->
    <h3 class="sub-title">Portefeuille client</h3>
    <p class="section-text">
      Chaque client dispose d'un portefeuille (solde créditeur). Ce solde est alimenté par des versements ou crédité lors des paiements. Pour consulter le portefeuille :
    </p>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Cliquez sur la ligne du client dans le tableau.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Le détail du portefeuille s'affiche : <strong>solde actuel</strong>, historique des mouvements (crédits, débits).</p>
      </div>
    </div>

    <div class="info-card tip">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#4caf50">lightbulb</span>
        Astuce
      </div>
      <p>
        Pour créditer le compte d'un client (avance ou remboursement), utilisez le module <strong>Caisse</strong> (voir section Caisse).
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocClients" };
</script>
